<template>
  <div class>
    <v-card elevation="0" outlined v-if="!loading" class="h-100 d-flex flex-column" min-height="350">
      <v-card-title>
        <v-icon color="secondary" large class="mr-2">people</v-icon>
        <div class="d-flex flex-column">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.myCollections")}}</span>
          <span
            class="subheader-font body-2"
          >{{$t('dashboards.lastCreated')}}</span>
        </div>
      </v-card-title>
      <div class="d-flex flex-column pl-3 pr-3 pb-1 mt-n2 flex-grow-1" v-if="collections && collections.length" style="overflow:auto">
        <CollectionCard v-for="(collection,index) in collections" :collection="collection" :key="index" embedded></CollectionCard>
      </div>
      <div class="d-flex flex-column px-3 py-4 mb-7 text-center flex-grow-1 justify-center align-center" v-if="!collections || !collections.length">
        <v-icon color="primary lighten-5" v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}">create_new_folder</v-icon>
        <span class="primary--text lighten--text-2 body-1">{{$t("dashboards.placeholderCollections")}}</span>
      </div>
      <v-divider class="my-1"></v-divider>
      <div class="d-flex justify-end px-2 py-2">
        <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/collections`">{{$t('dashboards.seeAllCollections')}}</v-btn>
      </div>
    </v-card>
    <v-card class="d-flex justify-center align-center py-8 px-12" v-if="loading">
      <v-progress-circular :size="75" color="secondary" indeterminate></v-progress-circular>
    </v-card>
  </div>
</template>

<script>
import CollectionService from "../../../services/collection.service";
import * as moment from 'moment';
import CollectionCard from '../../collections/CollectionCard';

export default {
  name: "CollectionsWidget",
  components:{
    CollectionCard
  },
  props: {
  },
  data() {
    return {
      collections: null,
      loading: false
    };
  },
  filters: {
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {
      this.loadCollections();
    },
    async loadCollections() {
      this.loading = true;
      let collectionsResponse = await CollectionService.getAvailableCollections();
      let allCollections = _.chain(collectionsResponse.data).forEach(c => c.updated = moment(c.updatedAt,'DD/MM/YYYY').format("YYYYMMDD")).orderBy(['updated','name'],['desc','asc']).value();
      this.collections = _.chain(allCollections).filter((c) => !c.isPublic).orderBy(['id'],['desc']).slice(0,4).value();
      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/CollectionsWidget.vue